import classNames from 'classnames';

import ParcelLocker from 'assets/icons/box.svg';
import Courier from 'assets/icons/bookmark.svg';
import FreeShipping from 'assets/icons/delivery.svg';
import Leasing from 'assets/icons/page.svg';
import Guarantee from 'assets/icons/guarantee.svg';
import Typography from '@components/atoms/Typography';
import { FormattedMessage, MessageDescriptor } from 'utils/intl';

import messages from './ShippingPicker.messages';
import classes from './ShippingPicker.module.scss';

type Variant = 'parcelLocker' | 'courier' | 'freeShipping' | 'leasing' | 'guarantee';

type Props = {
  variant: Variant;
  onItemClick?: () => void;
};

const shippingTitleMap: Record<Variant, MessageDescriptor> = {
  parcelLocker: messages.parcelLockerTitle,
  courier: messages.courierTitle,
  freeShipping: messages.freeShippingTitle,
  leasing: messages.leasingTitle,
  guarantee: messages.guaranteeTitle,
};

const shippingDescriptionMap: Record<Variant, MessageDescriptor> = {
  parcelLocker: messages.parcelLockerDescription,
  courier: messages.courierDescription,
  freeShipping: messages.freeShippingDescription,
  leasing: messages.leasingDescription,
  guarantee: messages.guaranteeDescription,
};

const ShippingPicker = ({ variant, onItemClick }: Props): JSX.Element => {
  const shippingIconMap: Record<Variant, JSX.Element> = {
    parcelLocker: <ParcelLocker className={classes.icon} />,
    courier: <Courier className={classes.icon} />,
    freeShipping: <FreeShipping className={classes.icon} />,
    leasing: <Leasing className={classes.icon} />,
    guarantee: <Guarantee className={classes.bigIcon} />,
  };

  return (
    <div className={classes.wrapper} onClick={onItemClick}>
      <div className={classes.iconWrapper}>{shippingIconMap[variant]}</div>
      <div>
        <Typography
          variant="caption1"
          renderAs="div"
          lineHeight="18px"
          className={classNames({ [classes.freeShipingTitle]: variant === 'freeShipping' })}
        >
          <FormattedMessage {...shippingTitleMap[variant]} />
        </Typography>
        <Typography
          variant="caption2"
          renderAs="div"
          lineHeight="13px"
          className={classNames(classes.description, {
            [classes.desktop]: ['freeShipping', 'guarantee'].includes(variant),
          })}
        >
          <FormattedMessage {...shippingDescriptionMap[variant]} />
        </Typography>
        {variant === 'guarantee' && (
          <Typography
            variant="caption2"
            renderAs="div"
            lineHeight="13px"
            className={classNames(classes.description, classes.mobile)}
          >
            <FormattedMessage {...messages.guaranteeDescriptionMobile} />
          </Typography>
        )}
      </div>
    </div>
  );
};

export default ShippingPicker;
